<template>
  <van-popup v-model="popup_coupon" pcloseable round :class="['applay-phone']" :style="{  width:'80%' }">
    <div>Get Coupon Name with your phone</div>
    <div>
      <van-field type="number" v-model="apply_phone" center clearable placeholder="Your Phone Number" />
      <van-button :class="'apply-button'" slot="button" size="normal" type="primary" @click="applyPhone">Submit</van-button>
    </div>
  </van-popup>
</template>
<script>
export default {
  data () {
    return {
      //弹出获取优惠券窗口，输入手机号码获取
      popup_coupon: false,
      apply_phone:''
    }
  },
  components: {
  },
  created () {
    this.isCouponPhone()
  },
  methods: {
    isCouponPhone () {
      // console.log('检查是否已经弹过COUPON窗口');
      setTimeout(() => { this.popup_coupon = true }, 200)
    },
    applyPhone () {
      // console.log('发送优惠券对应手机上');
      if (this.apply_phone !== '') {
        this.$toast('a coupon code sent to your phone')
      }
      this.popup_coupon = false
    },
  }
}
</script>
<style lang="less" scoped>
.applay-phone {
  padding: 20px 10px;
  .apply-button {
    margin: 10px 0 0 0;
  }
}
</style>